export default [
  {
    path: '/management_reports',
    name: 'management-reports',
    meta: {
      requiresAuth: true,
      title: 'Management Reports - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/ManagementReports'),
  },
  {
    path: '/permissions-matrix',
    name: 'permissions-matrix',
    meta: {
      requiresAuth: true,
      title: 'Permissions Matrix - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/PermissionsMatrix'),
  },
]
